import { forwardRef } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Text } from 'foundations-components/components/Text';
import { DISPLAY_VALUE_FALLBACK } from '../../constants/displayLabelFallback';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const SecondaryPropertyLabel = ({
  propertyLabel
}) => {
  return /*#__PURE__*/_jsx(Text, {
    paddingInlineEnd: "100",
    as: "span",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [propertyLabel, ':']
    })
  });
};
export const SecondaryPropertyDisplay = /*#__PURE__*/forwardRef(({
  propertyValue,
  propertyLabel,
  copyButtonComponent
}, ref) => {
  const displayValue = propertyValue || DISPLAY_VALUE_FALLBACK;

  // Override to use plain text in tooltip so that it will adjust the text color to fit its background color
  // https://git.hubteam.com/HubSpot/ProductSupport/issues/98099
  const tooltipContent = /*#__PURE__*/_jsxs("span", {
    children: [!!propertyLabel && `${propertyLabel}: `, displayValue]
  });
  return /*#__PURE__*/_jsxs(TruncateString, {
    useFlex: true,
    fixedChildren: copyButtonComponent,
    tooltip: tooltipContent,
    children: [!!propertyLabel && /*#__PURE__*/_jsx(SecondaryPropertyLabel, {
      propertyLabel: propertyLabel
    }), /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      as: "span",
      ref: ref,
      children: displayValue
    })]
  });
});